import { render, staticRenderFns } from "./FatworaRebackDetailByID.vue?vue&type=template&id=9b7e903e&"
import script from "./FatworaRebackDetailByID.vue?vue&type=script&lang=js&"
export * from "./FatworaRebackDetailByID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard-pharma/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
